import { useTheme } from '@emotion/react';
import {
  Badge,
  Box,
  Button,
  Dialog,
  Grid,
  ListItemIcon,
  MenuList,
  Typography,
  useMediaQuery,
} from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Layout } from 'antd';
import { getApiCall, postApiCall } from 'api/apiService';
import { ReactComponent as CollapseIcon } from 'assets/icons/collapse.svg';
import { ReactComponent as ExpandIcon } from 'assets/icons/expand.svg';
import AppHeader from 'component/AppHeader/AppHeader';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { MarketInvitePopup } from 'component/BuyersMarketplace/MarketInvitePopup';
import { Footerelements } from 'component/Footer';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import Moxochatloop from 'component/Moxochat/Moxochatloop';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import PropertySliderContent from 'component/PropertySliderContent//PropertySliderContent';
import { FCM_TOKEN, REAL_TIME, USER_TYPE } from 'constant/app.config';
import { MENU } from 'constants/menu.config';
import BuyerChat from 'modules/private/BuyerDashboard/BuyerChat';
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { poppins400, poppins500 } from 'theme/common.style';
import './AppLayout.css';
import Moxocall from 'modules/public/Moxocall/Moxocall';
import BuyerChats from 'component/Questionaire/BuyerChats';
import AgentChat from 'component/Questionaire/AgentChat';
import VendorChat from 'component/Questionaire/VendorChat';
import Message from '../private/Message/Message';
import { generateToken } from 'firebase.js';
import SiderComponent from 'component/sider';

const { Header, Content, Sider, Footer } = Layout;

const datacontext = createContext();
function AppLayout(props) {
  const { collapsed, setCollapsed, isScrolling, isBinderChatOpen } =
    useContext(PropertyContext);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesup = useMediaQuery(theme.breakpoints.up('xl'));
  const matchesxl = useMediaQuery(theme.breakpoints.down('xl'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;
  const { children } = props;
  // const [collapsed, setCollapsed] = useState(true);
  const [callwaiting, setCallwaiting] = useState();
  const [realTimeLog, setRealTimeLog] = useState(false);
  const [menubtn, setMenubtn] = useState(false);
  const [msgbtn, setMsgbtn] = useState(false);
  const [isDashboardActive, setDashboardActive] = useState(true);
  const [openlogin, setOpenlogin] = useState(false);
  const [solicitorupdate, setSolicitorupdate] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [msgcount, setMsgcount] = useState();
  const [progressCount, setProgressCount] = useState();
  const [notificationCount, setNotificationCount] = useState();
  const [selectedBuyerid, setSelectedBuyerid] = useState('');
  const [openbuyercard, setOpenbuyercard] = useState(false);
  const [moxochatloop, setMoxochatloop] = useState([]); //minimized moxochat bottom loop
  const [ischatopen, setIschatopen] = useState(''); //opened binderid
  const history = useHistory();
  const stickyAnchorRef = React.useRef(null);
  const [isOpenFileManager, setIsOpenFileManager] = useState(false); // file manager open close state

  // storefcmtoken API
  useEffect(() => {
    const setupFCM = async () => {
      try {
        const existingToken = sessionStorage.getItem('FCMTOKEN');
        const userDetail = JSON.parse(localStorage.getItem('userDetail'));

        if (!existingToken) {
          console.log(
            '🔄 Registering FCM service worker and generating token...'
          );
          const token = await generateToken();
          if (token) {
            console.log('✅ FCM token generated in AppLayout:', token);
            const fcmtokenPayload = {
              firebaseToken: token,
              userEmail: userDetail.userEmail,
              firebaseTokenFor: window.innerWidth < 500 ? 'App' : 'Web',
            };
            await postApiCall(FCM_TOKEN, fcmtokenPayload);
            console.log('📩 FCM token sent to backend.');
          } else {
            console.warn(
              '⚠️ Token generation failed or permission not granted.'
            );
          }
        } else {
          console.log('✅ Existing FCM token found, re-posting to backend.');
          const fcmtokenPayload = {
            firebaseToken: existingToken,
            userEmail: userDetail.userEmail,
            firebaseTokenFor: window.innerWidth < 500 ? 'App' : 'Web',
          };
          await postApiCall(FCM_TOKEN, fcmtokenPayload);
        }
      } catch (err) {
        console.error('❌ Error setting up FCM in AppLayout:', err);
      }
    };

    setupFCM();
  }, []);

  // left side bar messaging section opens
  const [showMessage, setShowMessage] = useState(false);
  const [messagedata, setMessagedata] = useState(null);
  useEffect(() => {
    if (showMessage == false) {
      setMessagedata(null);
    }
  }, [showMessage]);
  // left side bar messaging section closed

  const handleDashboardClick = () => {
    setDashboardActive(false);
  };
  const handleImageClick = () => {
    setDashboardActive(true);
  };
  const onCollapse = (c) => {
    setCollapsed(c);
  };

  const toggleMenu = () => {
    setCollapsed(!collapsed);
  };
  // const menu=(status)=>{
  //   setMenubtn(status);
  // }
  const currentPage = showMessage ? '/message' : window.location.pathname;

  const [abouttologgout, setAbouttologout] = useState(false);

  const [propertyId, setPropertyId] = useState(null);
  const location = useLocation();
  useEffect(() => {
    if (currentPage.includes('/call')) {
      setPropertyId(0);
    } else {
      // Split the pathname by '/'
      const segments = location.pathname.split('/');

      // Get the last segment which contains the dashboardId
      const dashboardId = segments[segments.length - 1];

      // Update state with the dashboardId value
      if (isNaN(dashboardId)) {
        setPropertyId(0);
      } else {
        setPropertyId(dashboardId);
      }
    }
  }, [location.pathname]);

  const [bannerFunctionTrigger, setBannerFunctionTrigger] = useState(false);

  const bannerApiTrigger = useCallback(() => {
    setBannerFunctionTrigger(true);
    const timer = setTimeout(() => {
      setBannerFunctionTrigger(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!currentPage.includes('/share')) {
      const fetchData = async () => {
        if (propertyId != null) {
          try {
            const res = await getApiCall(REAL_TIME + `/${propertyId}`);
            if (res?.data?.realTimeLog == 1) {
              setRealTimeLog((prevRealTimeLog) => !prevRealTimeLog);
            }
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      };
      fetchData();
      const intervalId = setInterval(fetchData, 10000);
      return () => clearInterval(intervalId);
    }
  }, [propertyId]);

  const primaryUserTypeValue = JSON.parse(localStorage.getItem('primaryUser'));

  const dataparams = {
    // sticky / UI
    isSticky,
    setIsSticky,
    onCollapse,
    toggleMenu,
    menubtn,

    // message related
    msgcount,
    setMsgcount,
    msgbtn,
    showMessage,
    setShowMessage,
    messagedata,
    setMessagedata,

    // progress / realtime
    progressCount,
    setProgressCount,
    realTimeLog,
    setRealTimeLog,

    // banner / api triggers
    bannerApiTrigger,
    bannerFunctionTrigger,

    // solicitor / notifications
    solicitorupdate,
    setSolicitorupdate,
    notificationCount,

    // buyer related
    selectedBuyerid,
    setSelectedBuyerid,
    openbuyercard,
    setOpenbuyercard,

    // moxo / chat
    moxochatloop,
    setMoxochatloop,
    ischatopen,
    setIschatopen,

    // call / auth
    callwaiting,
    setCallwaiting,
    openlogin,
    setOpenlogin,

    // file manager
    isOpenFileManager,
    setIsOpenFileManager,
  };

  return (
    <>
      <datacontext.Provider value={dataparams}>
        <Layout key="app-layout" className="app-layout">
          <div id="moxo-roots" style={{ display: 'none' }}></div>
          {!currentPage.includes('/Survey') &&
            !currentPage.includes('/Buyerfeedback') &&
            !currentPage.includes('/Agentfeedback') &&
            !currentPage.includes('/Vendorfeedback') && (
              <Header
                className="header"
                style={{
                  margin: '5px 0px',
                  position: 'fixed',
                  top: 0,
                  zIndex: 1000,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  display:
                    (matchessm &&
                      currentPage.includes('/market') &&
                      isScrolling &&
                      'none') ||
                    (matchessm &&
                      currentPage.includes('/dashboard') &&
                      isScrolling &&
                      'none'),
                  transition: 'opacity 0.5s ease',
                }}
              >
                <AppHeader
                  clickedmenu={setMenubtn}
                  clickedmessenger={setMsgbtn}
                  progressCount={Math.round(progressCount)}
                  setNotificationCount={setNotificationCount}
                  setSelectedBuyerid={setSelectedBuyerid}
                />
              </Header>
            )}

          {USER_TYPE === 'Agent' && (
            <div
              style={{
                marginTop: '72px',
                width: '100%',
                position: 'fixed',
                zIndex: 998,
                display: isScrolling && matchessm && 'none',
              }}
            >
              <PropertySliderContent />
            </div>
          )}
          {(currentPage.includes('/People') ||
            currentPage.includes('/landingpage') ||
            currentPage.includes('/dashboard') ||
            currentPage.includes('/BuyerDashboard') ||
            currentPage.includes('/VendorDashboard') ||
            currentPage.includes('/VendorIndividualDashboard') ||
            currentPage.includes('/VendorInactiveIndividual') ||
            currentPage.includes('/insights') ||
            currentPage.includes('/helpcentre') ||
            currentPage.includes('/invite') ||
            currentPage.includes('/pipeline') ||
            currentPage.includes('/ProfileSetting') ||
            currentPage.includes('/message') ||
            currentPage.includes('/tasks') ||
            currentPage.includes('/Savedsearch') ||
            currentPage.includes('/notification')) && (
            <Layout style={{ padding: '0px', height: '100%' }}>
              <SiderComponent />

              <Layout
                style={{
                  paddingLeft:
                    !matches &&
                    !currentPage.includes('/Savedsearch') &&
                    '106px',
                  backgroundColor: '#fbfbfb',
                  marginTop:
                    dataType?.length === 1 && primaryUserTypeValue !== 'Agent'
                      ? '75px'
                      : '125px',
                  // width:"1920px"
                }}
              >
                {!matchesup ? (
                  <Content
                    style={{
                      // overflow: "auto",
                      // paddingLeft: !matchesxl && "10px",
                      backgroundColor: '#fbfbfb',
                      minHeight: '100vh',
                      // marginTop:"70px"
                    }}
                    className="site-layout-background"
                  >
                    {children}
                  </Content>
                ) : (
                  <Content
                    style={{
                      // overflow: "auto",
                      backgroundColor: '#fbfbfb',
                    }}
                    className="site-layout-background"
                  >
                    {children}
                  </Content>
                )}
              </Layout>
            </Layout>
          )}
          {(currentPage.includes('/market') ||
            currentPage.includes('/share')) && (
            <Layout
              style={{
                padding: '0px',
                height: '100%',
                backgroundColor: 'white',
              }}
            >
              <Layout
                style={{
                  paddingLeft: !matches && '',
                  backgroundColor: '#fbfbfb',
                }}
              >
                {!msgbtn ? (
                  <Content
                    style={{
                      overflow: 'auto',
                      paddingLeft: !matchesxl && '',
                      // backgroundColor: "red",
                    }}
                    className="site-layout-background"
                  >
                    {children}
                  </Content>
                ) : !matchesup ? (
                  <MessagingContainer />
                ) : (
                  <Content
                    style={{
                      overflow: 'auto',
                      paddingLeft: !matchesxl && '',
                      backgroundColor: '',
                    }}
                    className="site-layout-background"
                  >
                    {children}
                  </Content>
                )}
              </Layout>
            </Layout>
          )}
          {currentPage.includes('/Survey') && <BuyerChat />}

          {currentPage.includes('/Buyerfeedback') && <BuyerChats />}

          {currentPage.includes('/Agentfeedback') && <AgentChat />}

          {currentPage.includes('/Vendorfeedback') && <VendorChat />}

          {moxochatloop?.length > 0 && (
            <Box
              sx={{
                width: '100%',
                height: '70px',
                position: 'fixed',
                bottom: '0px',
                display: 'flex',
                justifyContent: 'flex-end', // Aligns the inner content to the right
                overflowY: 'hidden', // Hides vertical scrolling
                right: '0px',
                zIndex: 20,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: moxochatloop?.length < 1 ? '0px' : '10px',
                  // paddingRight:ischatopen && "-10px",
                  overflowX: 'auto', // Enables horizontal scrolling on the content
                  overflowY: 'hidden', // Hides vertical scrolling
                }}
              >
                <Moxochatloop />
              </Box>
            </Box>
          )}

          {abouttologgout && (
            <Dialog
              open={true}
              PaperProps={{
                sx: {
                  borderRadius: '5px',
                  // height: matchessm ? "350px" : "300px",/
                  minWidth: matchessm ? '100%' : '400px',
                  boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                  padding: '30px',
                },
              }}
            >
              <Grid container height={'100%'}>
                <Grid item xs={12}>
                  <Typography
                    sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
                  >
                    Authentication Error
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  display={'flex'}
                  alignItems={'center'}
                  padding={'12px 0px 15px 0'}
                >
                  <Pendingwarning />
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: '22px',
                      paddingLeft: '12px',
                    }}
                  >
                    Session Expired - Please Reauthenticate
                  </Typography>
                </Grid>
                <Grid item xs={12} textAlign={'left'} paddingTop={'10px'}>
                  <Typography
                    sx={{ ...poppins400, fontSize: '16px', color: '#666666' }}
                    //   whiteSpace={"nowrap"}
                  >
                    Your session has expired or an authentication issue has
                    occurred. Please log in again to continue accessing your
                    account securely.
                  </Typography>
                </Grid>

                <Grid
                  item
                  container
                  direction="row"
                  sx={{ display: 'flex', alignItems: 'center' }}
                  justifyContent={'flex-end'}
                  gap={2}
                  marginTop={5}
                >
                  <Grid
                    item
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => {
                        history.push('/logout');
                      }}
                      style={{
                        padding: '10px 39px',
                        width: '100%',
                        height: '41px',
                        fontSize: '14px',
                        color: '#FFFFFF',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        background: '#4CA4D6',
                        borderRadius: '5px',
                        textTransform: 'capitalize',
                      }}
                    >
                      Okay
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Dialog>
          )}

          {openlogin && (
            <MarketInvitePopup
              open={openlogin}
              onClose={setOpenlogin}
              address={'retreX Invites !'}
            />
          )}

          {matches700 &&
            !currentPage.includes('/Savedsearch') &&
            !currentPage.includes('/Survey') &&
            !currentPage.includes('/Buyerfeedback') &&
            !currentPage.includes('/Agentfeedback') &&
            !currentPage.includes('/Vendorfeedback') && <Footerelements />}
        </Layout>

        {callwaiting &&
          callwaiting.isMeet == true &&
          !currentPage.includes('/message') && (
            <Moxocall
              callwaiting={callwaiting}
              setCallwaiting={setCallwaiting}
            />
          )}

        {showMessage && <Message />}
      </datacontext.Provider>
    </>
  );
}
export default AppLayout;
export { datacontext };
